module.exports = __webpack_public_path__ + "media/img/frontend_application/question-f153e49b2704d8332fbfa5c53f8349c5.png";